/* All the arrays of bike types */
var adventure_options_array = document.getElementsByClassName('modelz adventure');
var enduro_options_array = document.getElementsByClassName('modelz enduro');
var mx_options_array = document.getElementsByClassName('modelz mx');
var sport_options_array = document.getElementsByClassName('modelz sport');

/* Arrays of bike types stored in an object */

// var allBikeTypes = {
//   master: [
//     adventure_options_array,
//     enduro_options_array,
//     mx_options_array,
//     sport_options_array
//   ]
// }

/* Causing too many issues and crashing the filter */

// for (var i = 0; i < allBikeTypes.master.length; i++){ 
//   for (var j = 0; j < allBikeTypes.master[i].length; i++){
//     console.log(allBikeTypes.master[i][j])
//   }
// }

var modelz_adventure = [];
for (var i = adventure_options_array.length - 1; i >= 0; i-- ){
  modelz_adventure.push(adventure_options_array[i])
}

var modelz_enduro = [];
for (var i = enduro_options_array.length - 1; i >= 0; i-- ){
  modelz_enduro.push(enduro_options_array[i])
}

var modelz_mx = [];
for (var i = mx_options_array.length - 1; i >= 0; i-- ){
  modelz_mx.push(mx_options_array[i])
}

var modelz_sport = [];
for (var i = sport_options_array.length - 1; i >= 0; i-- ){
  modelz_sport.push(sport_options_array[i])
}

var all_modelz = {}
all_modelz.modelz_adventure = modelz_adventure;
all_modelz.modelz_enduro = modelz_enduro;
all_modelz.modelz_mx = modelz_mx;
all_modelz.modelz_sport = modelz_sport;

function clearModelMenu()  {
    try {
  var select = document.getElementById('model-menu');
  var mmLength = select.length - 1;
  for (var i = mmLength; i > 0; i--) {
    select.remove(i);
  }
    }
    catch(clearModelMenu_error) {
      console.log('ERROR: '+ clearModelMenu_error.message);
      // expected output: ReferenceError: nonExistentFunction is not defined
      // Note - error messages will vary depending on browser
    }
 
}

clearModelMenu();

function changeFunc(){
  
    try {  
  
        console.log('----------- changeFunc ----------');
        var bikeMenu = document.getElementById('bike-menu');
        var selectedBikeOption = bikeMenu.options[bikeMenu.selectedIndex].value;
        selectedBikeOption = selectedBikeOption.toLowerCase();  
        var modelName = 'modelz '+selectedBikeOption
        var x = document.getElementsByClassName(modelName);
        var y = document.getElementsByClassName('modelz');
        clearModelMenu();

        if (selectedBikeOption) {
          var newListName = modelName.replace(" ","_");
          for (var i = 0; i < all_modelz[newListName.valueOf()].length; i++){
            document.getElementById('model-menu').appendChild(all_modelz[newListName.valueOf()][i])
          }
        }
      
    }
    catch(changeFunc_error) {
      console.log('ERROR: '+ changeFunc_error.message);
      // expected output: ReferenceError: nonExistentFunction is not defined
      // Note - error messages will vary depending on browser
    }   
      
}

function selectModel() {
  
    try {
  
  var mm = document.getElementById('model-menu');
  var mv = mm.options[mm.selectedIndex].value

  var cm = document.getElementById('category-menu');
  var cv = cm.options[cm.selectedIndex].value

  if (mv && cv){
    document.getElementById('submit-filter').className = '';
    /*document.getElementById('submit-filter').removeAttribute('disabled');*/
  }
      
    }
    catch(cselectModel_error) {
      console.log('ERROR: '+ cselectModel_error.message);
      // expected output: ReferenceError: nonExistentFunction is not defined
      // Note - error messages will vary depending on browser
    }    
      
}


function submitFilter(){
  
    try {
  
  
  var bikeMenu = document.getElementById('bike-menu');
  var selectedBikeOption = bikeMenu.options[bikeMenu.selectedIndex].value;
  selectedBikeOption = selectedBikeOption.toLowerCase();
  
  var modelMenu = document.getElementById('model-menu');
  var selectedModelValue = modelMenu.options[modelMenu.selectedIndex].value

  var categoryMenu = document.getElementById('category-menu');
  var selectedCategoryValue = categoryMenu.options[categoryMenu.selectedIndex].value;
  
  // all provided
  if (bikeMenu.selectedIndex != 0 && modelMenu.selectedIndex !=0 && categoryMenu.selectedIndex !=0){
  	url = selectedModelValue + selectedCategoryValue.split('/collections')[1];
  }
  // only bike type provided
  else if (bikeMenu.selectedIndex != 0 && modelMenu.selectedIndex == 0 && categoryMenu.selectedIndex == 0){
  	url = '/collections/'+selectedBikeOption;
  }
  // only bike type and model provided (no product type)
  else if (bikeMenu.selectedIndex != 0 && modelMenu.selectedIndex != 0 && categoryMenu.selectedIndex == 0){
    url = selectedModelValue;
  }
  // only product type
  else if (bikeMenu.selectedIndex == 0 && modelMenu.selectedIndex == 0 && categoryMenu.selectedIndex != 0){
  	url = selectedCategoryValue;
  }
  // only bike type and product type provided (no model)
  else if (bikeMenu.selectedIndex != 0 && modelMenu.selectedIndex == 0 && categoryMenu.selectedIndex != 0){
    url = '/collections/' + selectedBikeOption + selectedCategoryValue.split('/collections')[1];;
  }
  // send to ALL collection
  else {
    url = '/collections/all'
  }
  
  /*debugger;*/

  location.href = `https://ktmtwins.com${url}`;
      
    }
    catch(submitFilter_error) {
      console.log('ERROR: '+ submitFilter_error.message);
      // expected output: ReferenceError: nonExistentFunction is not defined
      // Note - error messages will vary depending on browser
    } 
      
}

$(function() { 
  $('.filter-group ul:not(.has_selected)').each(function(){
    var max = 10;
    if ($(this).find("li:not(.selected)").length > (max+1)) {
      $(this).find('li:gt('+(max-1)+'):not(.selected)')
      .hide()
      .end()
      .append(
        $('<li class="view-more-link"><a href="javascript:;">View More...</a></li>').click( function(){
          $(this).siblings(':hidden').slideDown(100).end().slideUp(100);
        })
        );
    }
  });

  // $( "#bike-menu" ).change(function() {
  //   var adventure_options_array = $('.modelz.adventure');
  //   var enduro_options_array = $('.modelz.enduro');
  //   var mx_options_array = $('.modelz.mx');
  //   var sport_options_array = $('.modelz.sport');

  //   debugger;
  //   alert( "Tonka" );
  //   $('.hide').remove();
  // });

  // $(".select-wrapper option[value='X']").each(function() {
  //     $(this).remove();
  // });
});